import { Switch } from "@radix-ui/themes";
import { useEffect, useState } from "react";
import '@radix-ui/themes/styles.css';



const GdCompletePreparation = ({ onDone, setFileUrl, activePresentation }) => {
  const [prepOption, setPrepOption] = useState('');
  const [file, setFile] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setError('');
  }, [prepOption, file]);

  const handleDone = () => {
    if (prepOption === 'case_url' && !file) {
      setError('Please select document to upload!');
      return;
    }
    onDone();
  };

  const uploadDocument = async (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(selectedFile.type)) {
      try {
        // Placeholder for S3 upload logic; replace with actual implementation
        // const _url = await uploadFileonS3(selectedFile);
        const _url = { body: { postResponse: { location: URL.createObjectURL(selectedFile) } } }; // Mock for demo
        setFileUrl(_url?.body?.postResponse?.location);
        setFile(_url?.body?.postResponse?.location);
      } catch (error) {
        console.log('Unable to upload document due to:', error);
      }
    } else {
      console.log('Invalid file type. Please select a PDF, DOC, or DOCX file.');
    }
  };

  return (
    <div className="flex flex-1 flex-col justify-center items-center h-full">
      <span className="text-lg font-semibold text-gray-800 mb-6">
        Complete preparation for your presentation
      </span>

      <div className="flex items-center justify-between w-80 mb-4">
        <span className="text-base text-gray-600">Share Screen</span>
        <Switch
          checked={prepOption === 'share_screen'}
          onCheckedChange={(shareScreen) => {
            if (!shareScreen) {
              setPrepOption('');
              activePresentation('');
            } else {
              setPrepOption('share_screen');
              activePresentation('share_screen');
            }
          }}
          className="bg-gray-400 data-[state=checked]:bg-blue-600"
        />
      </div>

      <div className="flex items-center justify-between w-80 mb-4">
        <span className="text-base text-gray-600">Share Whiteboard</span>
        <Switch
          checked={prepOption === 'share_whiteboard'}
          onCheckedChange={(shareWhiteboard) => {
            if (!shareWhiteboard) {
              setPrepOption('');
              activePresentation('');
            } else {
              setPrepOption('share_whiteboard');
              activePresentation('share_whiteboard');
            }
          }}
          className="bg-gray-400 data-[state=checked]:bg-blue-600"
        />
      </div>

      <div className="flex flex-col items-center w-80">
        <div className="flex items-center justify-between w-full mb-4">
          <span className="text-base text-gray-600">Attach Document/ media to present</span>
          <Switch
            checked={prepOption === 'case_url'}
            onCheckedChange={(attachMedia) => {
              if (!attachMedia) {
                setPrepOption('');
                activePresentation('');
              } else {
                setPrepOption('case_url');
                activePresentation('case_url');
              }
            }}
            className="bg-gray-400 data-[state=checked]:bg-blue-600"
          />
        </div>

        {prepOption === 'case_url' && (
          <label className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors cursor-pointer mb-4">
            Upload Document
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={uploadDocument}
              className="hidden"
            />
          </label>
        )}
      </div>

      {error && (
        <span className="text-red-500 text-sm mb-4">{error}</span>
      )}

      <button
        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        onClick={handleDone}
      >
        Done
      </button>
    </div>
  );
};

export default GdCompletePreparation;